const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'perc_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_PERCS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_PERCS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_PERCS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_PERCS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_PERC':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.perc_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/percs.js